import { Deserializable } from '../../protocols/deserializable';

export class CopyAssetToTargetRequest implements Deserializable {
  public assetId: string;
  public md5Hash: string;
  public metadata: Map<string, string>;
  public targetMediaClass: string;

  public onDeserialize() {}

  // Expected go model:
  // https://github.com/mobilefirstdev/budsense-image-service/blob/dev/models/CopyAssetToTargetRequest.go
  public onSerialize() {
    const dto = Object.create(CopyAssetToTargetRequest.prototype);
    dto.assetId = this.assetId;
    dto.md5Hash = this.md5Hash;
    dto.metadata = this.metadata;
    dto.targetMediaClass = this.targetMediaClass;
    return dto;
  }
}
